'use strict';

import OrganizationsList from './list/organizations.list.ctrl';
import OrganizationsNew from './organizations.new.ctrl';
import OrganizationsEdit from './edit/editOrganization';

import OrganizationsTemplate from './organizations.template.ctrl';

export default angular
  .module('main.organizations', [
    OrganizationsList,
    OrganizationsNew,
    OrganizationsEdit,
    OrganizationsTemplate
  ])
  .name;
